"use client";

import React from 'react';
import { FeatherZap } from '@subframe/core';

interface AnimatedZapProps {
  className?: string;
}

/**
 * Animated lightning bolt icon with a flash/spark effect
 */
export const AnimatedZap: React.FC<AnimatedZapProps> = ({ className = '' }) => {
  return (
    <span className={`inline-flex relative ${className}`}>
      <style>{`
        @keyframes zap-flash {
          0%, 100% {
            opacity: 1;
            filter: drop-shadow(0 0 0px #eab308);
            transform: scale(1);
          }
          50% {
            opacity: 1;
            filter: drop-shadow(0 0 5px #eab308) drop-shadow(0 0 10px #facc15);
            transform: scale(1.05);
          }
        }
        .zap-icon {
          animation: zap-flash 2s ease-in-out infinite;
        }
      `}</style>
      <FeatherZap className="zap-icon text-yellow-500 fill-yellow-200" />
    </span>
  );
};
